//import moment from "moment"
//import 'moment/locale/lo'
//moment.locale('lo');

import moment from 'moment-timezone';
moment.tz.setDefault("Asia/Bangkok");

export default moment
